export default Object.freeze({
    PRACTICE: 'practice',
    USER: 'user',
})
